import { Reveal, SectionHeading } from "./Reveal";
import { useLang } from "@/constants/i18n";

export const About = () => {
    const { t } = useLang();
    return (
        <section id="fabiana" data-testid="about-section" className="bg-ivory py-24 md:py-32">
            <div className="mx-auto max-w-4xl px-5 md:px-10">
                <SectionHeading number="01" eyebrow={t.about.eyebrow} title={t.about.title} />
                <Reveal delay={0.15} className="space-y-6 text-base leading-relaxed text-ink/75 md:text-lg">
                    <p>{t.about.p1}</p>
                    <p>
                        {t.about.p2a}
                        <span className="font-medium text-burgundy">{t.about.p2Highlight}</span>
                        {t.about.p2b}
                    </p>
                    <p>{t.about.p3}</p>
                </Reveal>
                <Reveal delay={0.3}>
                    <div className="mt-12 flex flex-wrap gap-x-10 gap-y-4 border-t border-gold/30 pt-8">
                        {t.about.facts.map((fact) => (
                            <span
                                key={fact}
                                className="flex items-center gap-3 text-sm tracking-wide text-ink/70"
                            >
                                <span className="h-1.5 w-1.5 rotate-45 bg-gold" />
                                {fact}
                            </span>
                        ))}
                    </div>
                </Reveal>
            </div>
        </section>
    );
};

export default About;
